import { render, staticRenderFns } from "./batteryType.vue?vue&type=template&id=2d2ef66a&scoped=true&"
import script from "./batteryType.vue?vue&type=script&lang=js&"
export * from "./batteryType.vue?vue&type=script&lang=js&"
import style0 from "./batteryType.vue?vue&type=style&index=0&id=2d2ef66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ef66a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2ef66a')) {
      api.createRecord('2d2ef66a', component.options)
    } else {
      api.reload('2d2ef66a', component.options)
    }
    module.hot.accept("./batteryType.vue?vue&type=template&id=2d2ef66a&scoped=true&", function () {
      api.rerender('2d2ef66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/batteryType/batteryType.vue"
export default component.exports